import { Checkbox, Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import {
  IWorksheetComponent,
  WorksheetChartSection,
  WorksheetGridFieldSection,
  WorksheetRecordGrid,
} from 'Components/Worksheets/Core';

let MoistureConditionValueResultsSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <WorksheetGridFieldSection name="EmbeddedTests.Tests">
        <WorksheetRecordGrid
          name="EmbeddedTests.Tests"
          orientation="horizontal"
          rowHeaderWidth={200}
          recordProps={{
            width: 130,
            heading: 'number',
            headingLabel: 'Test Number',
            preventRemove: true,
            preventCreate: true,
          }}
          fieldSet={[
            {
              name: 'Data.Results.WaterContentPercent',
              component: <Field input={<TextOutput />} />,
            },
            {
              name: 'Data.Results.MoistureConditionValueText',
              component: <Field input={<TextOutput />} />,
            },
            {
              name: 'Data.Results.Exclude',
              component: <Field input={<Checkbox />} />,
            },
          ]}
        />
      </WorksheetGridFieldSection>
      <NamePrefixModifier namePrefix={'data.EmbeddedTests.McvChart'}>
        <WorksheetChartSection wide height={500} />
      </NamePrefixModifier>
    </>
  );
};

MoistureConditionValueResultsSection = withInjectedProps(MoistureConditionValueResultsSection);

export { MoistureConditionValueResultsSection };
export default MoistureConditionValueResultsSection;
